export interface MediaUrlSource {
  key?: string | null;
  url?: string | null;
  signed_url?: string | null;
  signedUrl?: string | null;
}

const HTTP_URL_PATTERN = /^https?:\/\//i;

function normalizeKey(value: string): string {
  if (!value) {
    return "";
  }
  if (HTTP_URL_PATTERN.test(value)) {
    try {
      const parsed = new URL(value);
      return parsed.pathname.replace(/^\/+/, "");
    } catch {
      return value.replace(/^https?:\/\/[^/]+\/?/, "").replace(/^\/+/, "");
    }
  }
  return value.replace(/^\/+/, "");
}

/**
 * Resolve media URL via environment CDN only.
 * Never returns direct object-storage absolute URLs.
 */
export function resolveMediaUrl(source: MediaUrlSource, imageCdn: string): string {
  const signedUrl = (source.signed_url || source.signedUrl || "").trim();
  if (HTTP_URL_PATTERN.test(signedUrl)) {
    return signedUrl;
  }

  const directKey = normalizeKey((source.key || "").trim());
  const fallbackKey = normalizeKey((source.url || "").trim());
  const key = directKey || fallbackKey;
  if (!key) {
    return "";
  }

  const normalizedCdn = (imageCdn || "").trim().replace(/\/+$/, "");
  if (!normalizedCdn) {
    return `/${key}`;
  }

  return `${normalizedCdn}/${key}`;
}
